import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editCertificate, updateCertificate } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditEnvCerts = props => {
  const dispatch = useDispatch()
  document.title = "Edit Certs"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editCertificate(id))
  }, [dispatch])

  const certs = useSelector(state => state.environmentalAndHealthCertification)

  useEffect(() => {
    let certificate = []
    if (
      certs &&
      certs.environmentalAndHealthCertification &&
      certs.environmentalAndHealthCertification.length > 0
    ) {
      certificate = certs.environmentalAndHealthCertification.filter(
        environmentalAndHealthCertification =>
          environmentalAndHealthCertification.id == id
      )
    }
    if (certificate.length > 0) {
      setDetails(certificate[0])
    } else {
      props.history.push("/dropdown/env_health_certificate/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      certification_id:
        details && details.certification_id ? details.certification_id : "",

      certification:
        details && details.certs ? details.certs : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      certification: Yup.string().required("Please enter Env Certificate"),
    }),
    onSubmit: values => {
      values.certification_id = id // certification_id is from api thats why this needs to be same with "id"
      dispatch(updateCertificate(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.environmentalAndHealthCertification.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Environment and Health Certification" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editEnvForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="env">
                            Environment and Health Certification
                          </Label>
                          <Input
                            name="certification"
                            type="text"
                            id="env"
                            placeholder="Enter"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.certification || ""}
                          />
                          {validation.touched.certification &&
                          validation.errors.certification ? (
                            <FormFeedback type="invalid">
                              {validation.errors.certification}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {certs && certs.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditEnvCerts
